import React from 'react';
import styles from './SpinClock.less';

function SpinClock() {
  return (
    <div className={styles.container}>
      <div className={styles.item}></div>
      <div className={styles.itemSpin}>
        <div className={styles.item}></div>
      </div>
    </div>
  );
}

export default SpinClock;
